
import { defineComponent, reactive, ref, watchEffect } from "vue";
import { loginModel } from "@/interfaces/account.interface";
import { LocationQueryValue, useRoute, useRouter } from "vue-router";
import { useUserStore } from "@/store";
import { CheckMsg } from "@/constants/message.constant";
import { getMenteComment } from "@/api/menteComment.api";
import { MenteComment } from "@/interfaces/menteComment.interface";

export default defineComponent({
  name: "Login",
  setup() {
    const userStore = useUserStore();
    const router = useRouter();
    const route = useRoute();
    let redirect: LocationQueryValue = null;
    const ruleForm = reactive({
      email: "",
      password: "",
    } as loginModel);
    const loginForm = ref();
    const rules = {
      email: [
        {
          required: true,
          trigger: "blur",
          message: CheckMsg.CHK_MAIL,
        },
        {
          type: "email",
          trigger: "blur",
          message: CheckMsg.CHK_MAIL2,
        },
      ],
      password: [
        { required: true, message: CheckMsg.CHK_PWD, trigger: "blur" },
      ],
    };
    const loading = ref(false);
    const mente = reactive({
      id: "",
      menteHyoujiFlg: false,
      menteComment: "",
      menteTitle: ""
    } as MenteComment);

    watchEffect(() => {
      redirect = route.query?.redirect as LocationQueryValue;
    });

    const handleLogin = () => {
      loginForm.value?.validate(async (valid: unknown) => {
        if (valid) {
          loading.value = true;
          try {
            await userStore.login(ruleForm);
            router.push({ path: redirect || "/" });
            loading.value = false;
          } catch (error) {
            loading.value = false;
          }
        } else {
          return false;
        }
      });
    };

    const setMenteComment = async () => {
      const {
        data: { result },
      } = await getMenteComment();
      if (result.mente_hyouji_flg) {
        mente.menteHyoujiFlg = true;
        mente.menteComment = result.mente_comment;
        mente.menteTitle = result.mente_title;
      }
    };
    setMenteComment();

    return {
      loading,
      ruleForm,
      loginForm,
      rules,
      handleLogin,
      mente,
    };
  },
});
